import { ENDPOINTS } from '@constants'
import { IUser } from '@typings'
import { BaseApi } from '../api/_base.api'

export class UserApi extends BaseApi {
  whoAmI = () => this.api.get(ENDPOINTS.USER.WHO_AM_I).then(res => res.data.data)

  update = async (data: IUser) => await this.api.put(ENDPOINTS.USER.UPDATE, data).then(res => res.data.data)

  requestEmailChange = async (data: { new_email: string; current_password: string }) =>
    await this.api.post(ENDPOINTS.USER.REQUEST_EMAIL_CHANGE, data).then(res => res.data)

  cancelEmailChange = async () => await this.api.post(ENDPOINTS.USER.CANCEL_EMAIL_CHANGE).then(res => res.data)

  resendEmailChange = async () => await this.api.post(ENDPOINTS.USER.RESEND_EMAIL_CHANGE).then(res => res.data)
}
